import { c as create_ssr_component, h as add_attribute, e as escape, v as validate_component } from "../../../../chunks/index.js";
/* empty css                                                         */import { T as Topbar } from "../../../../chunks/Topbar.js";
const css = {
  code: ".scene{perspective:1000px;background-color:white}.card{width:100%;height:100%;transition:transform 0.8s;transform-style:preserve-3d;cursor:pointer;position:relative}.card:hover{transform:rotateY(180deg)}.card__face{position:absolute;width:100%;height:100%;-webkit-backface-visibility:hidden;backface-visibility:hidden}.card__face--back{transform:rotateY(180deg)}",
  map: null
};
const CardText = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { title } = $$props;
  let { text } = $$props;
  let { bgBackColor } = $$props;
  let { fadeDelay } = $$props;
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.text === void 0 && $$bindings.text && text !== void 0)
    $$bindings.text(text);
  if ($$props.bgBackColor === void 0 && $$bindings.bgBackColor && bgBackColor !== void 0)
    $$bindings.bgBackColor(bgBackColor);
  if ($$props.fadeDelay === void 0 && $$bindings.fadeDelay && fadeDelay !== void 0)
    $$bindings.fadeDelay(fadeDelay);
  $$result.css.add(css);
  return `<div${add_attribute("class", `scene ${$$props.class}`, 0)}><div class="${"card"}"><div${add_attribute("class", `card__face card__face--front grid grid-rows-2 px-6 py-6 ${$$props.class}`, 0)}><div class="${"text-2xl text-white self-end row-start-2"}">${slots.default ? slots.default({}) : ``}</div></div>
			<div${add_attribute("class", `card__face card__face--back text-white grid grid-rows-2 px-6 py-6 ${bgBackColor}`, 0)}><div class="${"text-xl border-b border-white border-solid"}"><p>${escape(text)}</p></div>
				<div class="${"row-start-2 self-end grid grid-cols-2 row-start-2"}">${escape(title)}
					<svg class="${"w-6 h-6 justify-self-end"}" fill="${"currentColor"}" viewBox="${"0 0 20 20"}" xmlns="${"http://www.w3.org/2000/svg"}"><path fillrule="${"evenodd"}" d="${"M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"}" cliprule="${"evenodd"}"></path></svg></div></div></div></div>`;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  return `<section class="${"h-screen grid grid-cols-2"}"><div>${validate_component(Topbar, "Topbar").$$render(
    $$result,
    {
      light: true,
      class: "h-16 ml-24 w-[42%] fixed mt-10 grid grid-cols-2 z-20"
    },
    {},
    {}
  )}
        <div class="${"h-full"}"><img class="${"w-full h-full object-cover brightness-75"}" src="${"https://v3.gva-it.ch/wp-content/uploads/2021/06/Fernand-Maintenance.gif"}"></div></div>
    <div class="${"grid grid-cols-6 grid-rows-3"}">${validate_component(CardText, "CardText").$$render(
    $$result,
    {
      class: "bg-blue-600 col-span-3 row-start-1",
      title: "En savoir plus",
      text: "Notre syst\xE8me de monitoring et notre pro-activit\xE9 au service de la disponibilit\xE9 de votre infrastructure.",
      bgBackColor: "bg-gray-900",
      fadeDelay: 450
    },
    {},
    {
      default: () => {
        return `Serveur VPS`;
      }
    }
  )}
        ${validate_component(CardText, "CardText").$$render(
    $$result,
    {
      class: "bg-blue-400 col-span-3 row-start-1",
      title: "En savoir plus",
      text: "Votre application de gestion, custom, site internet ou autres, h\xE9berg\xE9es dans notre datacenter situ\xE9 dans le Grand-Gen\xE8ve.",
      bgBackColor: "bg-gray-900",
      fadeDelay: 650
    },
    {},
    {
      default: () => {
        return `Microsoft Exchange`;
      }
    }
  )}
        ${validate_component(CardText, "CardText").$$render(
    $$result,
    {
      class: "bg-blue-400 col-span-3 row-start-2",
      title: "En savoir plus",
      text: "Nos experts aux services du maintien ou de la mise en place de votre call-center, 3CX, peoplephone, etc...",
      bgBackColor: "bg-gray-900",
      fadeDelay: 850
    },
    {},
    {
      default: () => {
        return `CRM Odoo`;
      }
    }
  )}
        ${validate_component(CardText, "CardText").$$render(
    $$result,
    {
      class: "bg-blue-900 col-span-3 row-start-2",
      title: "En savoir plus",
      text: "Obtenez votre mat\xE9riel informatique au meilleur prix.",
      bgBackColor: "bg-gray-900",
      fadeDelay: 950
    },
    {},
    {
      default: () => {
        return `GVA Drive`;
      }
    }
  )}
        <div class="${"h-full w-full col-span-6 bg-gray-900 grid grid-rows-3 p-9"}"><p class="${"text-white w-3/4 row-span-2 flex items-end self-center"}">En fonction de votre projet, nous vous fournissons une infrastructure performante et 100% modulable. Un h\xE9bergement de proximit\xE9 : notre solution d\u2019h\xE9bergement vous permet d\u2019optimiser les co\xFBts informatiques et obtenir une flexibilit\xE9 et une haute disponibilit\xE9 de votre infrastructure IT.
            </p>
            <h1 class="${"h-full flex text-4xl text-white font-medium items-end justify-end border-t border-solid border-white border-opacity-30"}">Solutions H\xE9berg\xE9es
            </h1></div></div></section>`;
});
export {
  Page as default
};
